module.exports = __webpack_public_path__ + "assets/img/Sure_btn.5af25630.png";